<template>
  <base-alert
    :modalId="'remove-vehicle-model-' + tripID"
    icon="popup-warning-icon"
    :title="$t('remove-vehicle')"
    :description="$t('journey-remove-vehicle-warning-msg')"
  >
    <template #buttons>
      <base-button
        id="remove-trip-warning-modal-cancel-btn"
        variant="secondary"
        @click="hideModal"
        class="col-3 mb-3"
      >
        {{ $t('no') }}
      </base-button>
      <base-button
        id="remove-trip-warning-modal-submit-btn"
        variant="primary"
        @click="removeVehicle"
        class="col-3 mb-3"
      >
        {{ $t('yes') }}
      </base-button>
    </template>
  </base-alert>
</template>

<script>
export default {
  props: ['tripID'],
  emits: ['removeVehicle'],
  methods: {
    hideModal() {
      this.$bvModal.hide('remove-vehicle-model-' + this.tripID)
    },
    removeVehicle() {
      this.$emit('removeVehicle')
      this.hideModal()
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/reservationOperations.json'),
      ar: require('@/services/i18n/locales/ar/reservationOperations.json'),
    },
  },
}
</script>
